import { render, staticRenderFns } from "./SinglePostSkeleton.vue?vue&type=template&id=028672eb&scoped=true"
import script from "./SinglePostSkeleton.vue?vue&type=script&lang=js"
export * from "./SinglePostSkeleton.vue?vue&type=script&lang=js"
import style0 from "./SinglePostSkeleton.vue?vue&type=style&index=0&id=028672eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028672eb",
  null
  
)

export default component.exports